import React from 'react';
import './dashboard-profile-image-upload.sass';
import { useDispatch, useSelector } from 'react-redux';
import { deleteVendorPhoto, setProfilePhoto, uploadVendorPhoto } from '../../dashboard-profile.slice';
import { getSession, getTeamVendorId } from '../../../../login/session.slice';
import { unwrapResult } from '@reduxjs/toolkit';
import starIcon from '../../../assets/Star.png';
import filledStarIcon from '../../../assets/Star_filled.png';
import trashIcon from '../../../assets/Trash.png';
import { toast } from 'react-toastify';

export const DashboardProfileImageUpload = ({img, id, isProfile = false}) => {

  const MAX_SIZE_IMAGE = 1000000 * 5;

  const dispatch = useDispatch();
  const sessionData = useSelector(state => state.session);
  const vendorId = getTeamVendorId(sessionData);

  const onImageSelect = e => {
    const data = new FormData();

    if(e.target.files[0].size > MAX_SIZE_IMAGE) {
      toast.error('Maksymalny rozmiar zdjęcia to 5MB!');
      return;
    }

    data.append('image', e.target.files[0]);
    dispatch(uploadVendorPhoto({vendorId, payload: data}))
      .then(unwrapResult)
      .then( () => {
        dispatch(getSession({}));
        e.target.value = null;
      });
  };

  const onImageDelete = () => {
    dispatch(deleteVendorPhoto({vendorId, photoId: id}))
      .then(unwrapResult)
      .then( () => {
        dispatch(getSession({}));
      });
  };

  const setProfileImage = () => {
    dispatch(setProfilePhoto({vendorId, photoId: id}))
        .then(unwrapResult)
        .then(() => {
          dispatch(getSession({}));
        });
  };

  const renderImageContainer = () => {
    return <div className='vv-dashboard-profile-image-upload__image' style={{backgroundImage: `url(${img})`}}>
      <div className='vv-dashboard-profile-image-upload__image-menu'>
        <div className='profile-image-icon-text'>
          {
            isProfile ?
                <>
                  <img src={filledStarIcon} alt='star icon'/>
                  <p>PROFILOWE</p>
                </>
              :
                <img src={starIcon} alt='star icon' className='vv-dashboard-profile-image-upload__icon' onClick={setProfileImage}/>
          }

        </div>
        <img className='vv-dashboard-profile-image-upload__delete-icon' onClick={onImageDelete} src={trashIcon} alt='trash icon'/>
      </div>
    </div>;
  };

  const renderAddImageText = () => {
    return <>
      <label className='vv-dashboard-profile-image-upload__label'>
        <span className='vv-dashboard-profile-image-upload__text'>+ DODAJ ZDJĘCIA</span>
        <input type='file' id='single' onChange={onImageSelect}/>
      </label>
    </>;
  };

  return (
    <div className='vv-dashboard-profile-image-upload'>
      {img ? renderImageContainer() : renderAddImageText()}
    </div>
  );
};
